import React, { Suspense } from 'react';
import { useSelector } from 'react-redux';

import { VN_COUNTRY_LOCATION } from '../../../../../common/constants';
import useGetCompanyVerificationInfo from '../../../../../common/hooks/useGetCompanyVerificationInfo';
import { Company } from '../../../../../common/interfaces/entities';
import { useCompanyVerificationModalsContext } from '../../../../../components/CompanyVerificationModals/CompanyVerificationModalsProvider';
import CompanyTierVerificationModal from '../../../../../components/Modal/CompanyTierVerificationModal/CompanyTierVerificationModal';
import { getSessionCompany } from '../../../../../selectors/session';
import CompanyVerificationModal from './CompanyVerificationModal';
import VNCompanyVerificationModal from './VNCompanyVerificationModal';

const CompanyVerificationModalVariantController = () => {
  const company: Company | undefined = useSelector(getSessionCompany);
  const { canShowCompanyVerificationModal } = useGetCompanyVerificationInfo();
  const { isVerificationModalOpen } = useCompanyVerificationModalsContext();

  return (
    <Choose>
      <When condition={company?.CountryCode === VN_COUNTRY_LOCATION.code}>
        <VNCompanyVerificationModal />
      </When>
      <Otherwise>
        <Choose>
          <When condition={canShowCompanyVerificationModal}>
            <Suspense fallback={null}>
              {isVerificationModalOpen && <CompanyTierVerificationModal />}
            </Suspense>
          </When>
          <Otherwise>
            <CompanyVerificationModal />
          </Otherwise>
        </Choose>
      </Otherwise>
    </Choose>
  );
};

export default CompanyVerificationModalVariantController;
